<template>
  <v-card>
    <FufuHeader>
      入力完了
    </FufuHeader>

    <!-- <v-card-text>
      <v-layout justify-center class="display-1">
        <b class="red--text">スタッフにこの画面をお見せください</b>
      </v-layout>
    </v-card-text> -->

    <v-card-text>
      <v-flex class="primary--text text-center py-6 display-1 grey lighten-4">
        <b>お客さまID：{{ form.account }}</b>
      </v-flex>
    </v-card-text>

    <v-card-text>
      <NoticeCheck
        :patch-test.sync="form.patchTest"
        :notice-checks.sync="form.noticeChecks"
        hide-input
      />
    </v-card-text>

    <v-card-text>
      <h3 class="primary--text text-center my-5">送信内容</h3>
    </v-card-text>

    <v-card-text>
      <v-divider />
      <ConfirmInputData :questions="questions" :form="form" />
      <v-divider />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import FufuHeader from '@/components/FufuHeader'
import NoticeCheck from '@/components/NoticeCheck'
import ConfirmInputData from '@/components/ConfirmInputData'

export default {
  name: 'DoneView',
  components: {
    FufuHeader,
    NoticeCheck,
    ConfirmInputData,
  },
  data: () => ({
    form: null,
  }),
  computed: {
    ...mapGetters(['questions']),
  },
  created() {
    this.form = Object.assign({}, JSON.parse(this.$route.query.form))
  },
  mounted() {
    window.scrollTo({
      top: 0,
    })
  },
  methods: {
    done() {
      // NOTE: window.closeはwindow.openで開いた場合のみ可能
      // window.close()
    },
  },
  async beforeRouteEnter(to, from, next) {
    try {
      let form = Object.assign({}, JSON.parse(to.query.form))
      await store.dispatch('fetchQuestions')
      next(vm => {
        vm.form = form
      })
    } catch (err) {
      next(err)
    }
  },
}
</script>
